import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router';
import { api } from '../../shared/api/client';
import type { AppNotification } from '../../shared/api/types';
import { Icon } from '../shell/nav';
import { useLiveVersion } from '../../shared/live';
import { setAppBadge } from '../../shared/push/app-badge';

const POLL_MS = 60_000;

/**
 * Campana con el número de notificaciones sin leer. Se actualiza al instante (canal en vivo), al
 * navegar, al volver a la app y cada minuto; el mismo número va al globo del ícono de la app.
 */
export function NotificationBell() {
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);
  const live = useLiveVersion((e) => e.type === 'notification' || e.kind === 'notifications.read' || e.kind === 'notifications.resolved');

  useEffect(() => {
    const controller = new AbortController();
    const load = () =>
      api
        .get<{ items: AppNotification[]; unread: number }>('/notifications/me', controller.signal)
        .then((r) => {
          setUnread(r.unread);
          setAppBadge(
            r.unread,
            r.items.filter((n) => !n.readAt && !n.resolvedAt),
            r.items.filter((n) => n.resolvedAt).map((n) => n.id),
          );
        })
        .catch(() => undefined);
    void load();
    const timer = setInterval(load, POLL_MS);
    const onVisible = () => document.visibilityState === 'visible' && void load();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      controller.abort();
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [pathname, live]);

  const label = unread === 0 ? 'Notificaciones' : `Notificaciones (${unread} sin leer)`;
  return (
    <NavLink to="/app/notificaciones" className="bell" aria-label={label} title={label}>
      <Icon name="bell" />
      {unread > 0 ? <span className="bell__count">{unread > 99 ? '99+' : unread}</span> : null}
    </NavLink>
  );
}
